import * as Immutable from "immutable";
import mapValues from "lodash/mapValues";
import FieldUnit from "views/logic/aggregationbuilder/FieldUnit";
export default class UnitsConfig {
  constructor(units) {
    this._value = units;
  }
  getFieldUnit(fieldName) {
    return this._value[fieldName];
  }
  toJSON() {
    const units = this._value;
    return mapValues(units, (unit) => unit.toJSON());
  }
  toFormValues() {
    const units = this._value;
    return mapValues(units, (unit) => ({ unitType: unit.unitType, abbrev: unit.abbrev }));
  }
  static fromJSON(value) {
    const unitsJson = value;
    const units = mapValues(unitsJson, (unit) => FieldUnit.fromJSON(unit));
    return new Builder(Immutable.Map(units)).build();
  }
  static empty() {
    return new UnitsConfig({});
  }
  toBuilder() {
    const units = this._value;
    return new Builder(Immutable.Map(units));
  }
}
export class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  static create(values) {
    return new Builder(Immutable.Map(values));
  }
  setFieldUnit(fieldName, value) {
    return new Builder(this.value.set(fieldName, value));
  }
  merge(values) {
    return new Builder(this.value.merge(values));
  }
  build() {
    const units = this.value.toObject();
    return new UnitsConfig(units);
  }
}
